/* src/app/common/components/filters/filters.component.scss */
.custom-filters {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0;
  align-items: center;
}
.filter {
  display: flex;
  flex-direction: column;
  width: 200px;
}
.filter-label {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  color: #444;
  font-weight: 600;
}
@media screen and (max-width: 600px) {
  .filter {
    margin-left: 4px;
    width: 100% !important;
  }
}
/*# sourceMappingURL=filters.component.css.map */
